;(function(w){
	function SectionsHolder(){
		var self =this;
		this.main = document.getElementById('sections_holder');

		var cant_sections = $('.section').length;

		var actual = 0;

		var animando = false;

		
		this.set = function(route_key){
			animando = true;
			
			$(self.main).trigger('SECTIONS_HOLDER_ANIMATION_START');

			var element = $(self.main).find('section[data-url-key="'+route_key+'"]')[0];

			var prev = actual;

			actual = cant_sections - $(element).index() - 1;
			
			var animation_time = Math.abs(actual - prev)*800;

			$(self.main).animate({bottom: -actual*$(window).height()},animation_time, 'easeInOutCubic', function(){
				animando = false;

				$(self.main).trigger('SECTIONS_HOLDER_ANIMATION_END');
			});

			setTimeout(function(){
				$(element).find('.wow:not(.animated)').removeAttr('style').addClass('animated');

			}, (animation_time > 0) ? animation_time - 800 : 0);

		}

		this.estaAnimando = function(){
			return animando;
		}

		this.resize = function(){
			$('.section').each(function(){
				$(this).css('height', $(window).height());
			})


			$(self.main).css('bottom', -actual*$(window).height());
		}
		
	}
	
	w.SectionsHolder = SectionsHolder;
})(window)